module.exports = __webpack_public_path__ + "static/img/audio_pic8.b2e3469.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/audio_pic8.png
// module id = AcS9
// module chunks = 0